var marketSelector = {
	selectionLabel: "Selecteer een Markt"
};
var nl = {
	marketSelector: marketSelector
};

export { nl as default, marketSelector };
